import actions from "./actionTypes";
import config from "../../../config/config";
import moment from "moment";

const {
  REQUEST_QUESTIONNAIRES,
  RECIEVE_QUESTIONNAIRES,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS,
  REQUEST_TEMPLATES,
  RECIEVE_TEMPLATES,
  TEMPLATE_CLEAR_ERRORS,
  TEMPLATE_SERVER_ERROR_OCCURED
} = actions;

function hasError(errors) {
  return {
    type: SERVER_ERROR_OCURED,
    errors,
  };
}

function hasTemplateError(errors) {
  return {
    type: TEMPLATE_SERVER_ERROR_OCCURED,
    errors
  }
}

export function fecthQuestionnaires(token) {
  return fetch(`${config.URI}/api/v1/questionnaires`, {
    headers: {
      "Authenticity-Token": token,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      throw Error(res.statusText)
    }
  });
}

export function getTemplates(token) {
  return function(dispatch) {
    dispatch({ type: REQUEST_TEMPLATES });
    fetchTemplates(token).then(res => {
      if(res && res.status && res.status === 'success') {
        dispatch({ type: RECIEVE_TEMPLATES, templates: res.data.templates.map(template => {
          template.options = JSON.parse(template.options) || [];
          return template;
        }) });     
      } else {
        console.error(res.errors)
      }
    }).catch(error => {
      dispatch(hasTemplateError(error));
      console.error(error);
    })
  }
}

export function fetchTemplates(token) {
  return fetch(`${config.URI}/api/v1/templates`, {
    headers: {
      "Authenticity-Token": token,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      throw Error(res.statusText)
    }
  });
}

export function getQuestionnaires(token) {
  return function(dispatch) {
    dispatch({ type: REQUEST_QUESTIONNAIRES });
    fecthQuestionnaires(token).then(res => {
      if(res && res.status && res.status === 'success') {
        const questionnaireList = modifyQuestionnaire(res.data.questionnaires.filter(q => !q.last_submitted_at));
        const results = modifyQuestionnaire(res.data.questionnaires.filter(q => q.last_submitted_at));
        console.log(questionnaireList, results);
        dispatch({ type: RECIEVE_QUESTIONNAIRES, questionnaires: questionnaireList, results });
      } else {
        console.error(res.errors);
      }
    }).catch(error => {
      dispatch(hasError(error));
      console.error(error);
    })
  }
}

function modifyQuestionnaire(questionnaires) {
  return questionnaires.map(question => {
    question.options = JSON.parse(question.options) || [];
    question.answers = JSON.parse(question.answers) || [];
    question.isResultExpired = isQuestionResultExpired(question);
    return question;
  })
}

function isQuestionResultExpired(questionnaire) {
  if(questionnaire.last_submitted_at) {
    const startDate = moment(moment(questionnaire.last_submitted_at).format('DD/MM/YYYY'), "DD/MM/YYYY");
    const endDate = moment(moment(new Date()).format("DD/MM/YYYY"), "DD/MM/YYYY");
    const diff = endDate.diff(startDate, 'days');
    return diff < 30 ? false : true;
  } else {
    return false;
  }
}

export function clearErrors() {
  return function(dispatch) {
    dispatch({ type: CLEAR_ERRORS });
  }
}

export function clearTemplateErrors() {
  return function(dispatch) {
    dispatch({ type: TEMPLATE_CLEAR_ERRORS });
  }
}




// WEBPACK FOOTER //
// src/routes/Questionnaire/actions/index.js